<!-- 调查问卷管理界面 -->
<template>
  <div class="access-record-container question-manage">
    <!--主页面 -->
    <div class="flex-row" style="height: 100%">
      <div class="flex-auto flex-valign" style="overflow: hidden">
        <!-- 右侧表格 -->
        <div class="section-main_table">
          <ioc-table
            ref="accessTab"
            :data="tableData"
            :option="tableOption"
            :page="page"
            @row-cancle="closeDialog"
            @search-change="searchResult"
            @search-reset="resetQuery"
            @current-change="selectPage"
            @size-change="changeSize"
            @selection-change="handleSelectionChange"
          >
            <!-- 表格搜索条件 自定义 -->
            <!-- 类型 -->
            <template slot="search_type">
              <div>
                <el-select v-model="searchParams.type" placeholder="请选择">
                  <el-option
                    v-for="item in quesTypeOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
            <!-- 状态-->
            <template slot="search_status">
              <div>
                <el-select v-model="searchParams.status" placeholder="请选择">
                  <el-option
                    v-for="item in quesStatusOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </template>
            <!-- 上方按钮 -->
            <template slot="menuLeft">
              <el-button
                type="primary"
                size="small"
                class="iss-operation-button"
                icon="el-icon-plus"
                @click="handleAddCar"
              >
                新增
              </el-button>
              <el-button
                size="small"
                icon="el-icon-delete"
                class="iss-operation-button"
                @click="handelDelQues"
                :disabled="!checkedQuesIds.length ? true : false"
              >
                批量删除
              </el-button>
            </template>
            <!-- 自定义操作列 -->
            <template slot="menu" slot-scope="scope">
              <el-tooltip
                class="item"
                effect="dark"
                content="修改"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-xiugai"
                  @click="handleEditOpt(scope.row)"
                  :disabled="scope.row.status == 2"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="发布"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont iconjiantou-copy-copy1"
                  @click="handlePublish(scope.row, scope.index)"
                  :disabled="scope.row.status == 2"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="删除"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-shanchu"
                  @click="handleDel(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="详情"
                placement="top"
                popper-class="tooltip-draw"
              >
                <el-button
                  type="text"
                  icon="iconfont icon-Detail"
                  @click="handleView(scope.row, scope.index)"
                ></el-button>
              </el-tooltip>
            </template>
            <!-- 表格列 自定义 -->
            <template slot="twoDimensionCode" slot-scope="scope">
              <div @click="showCode(scope.row)" v-if="scope.row.status == 2">
                <vue-qr
                  :logoSrc="downloadData.icon"
                  :text="h5Url + '?id=' + scope.row.id + '&type=' + scope.row.type"
                  style="cursor: pointer"
                  :size="50"
                  :margin="5"
                ></vue-qr>
              </div>
              <!-- <img
                :src="getImgPath(scope.row.twoDimensionCode)"
                onerror="this.src='/images/theme/newDark/default.png'"
                style="height: 50px; width: 50px"
                @click="
                  showViewer(getImgPath(scope.row.twoDimensionCode), $event)
                "
              /> -->
            </template>
          </ioc-table>
        </div>
      </div>
    </div>
    <!--详情-->
    <appPanel
      :width="760"
      class="app-panel"
      :isExpand="showPanel"
      @cancel="handleClosePanel"
      title="调查问卷详情"
    >
      <div class="question-detail-box">
        <!-- 上方图表区域 -->
        <div class="detail-chart-box">
          <div class="chart-left-box">
            <h3 style="width: 90%; margin: 10px auto">作答人数统计</h3>
            <div class="left-content-box">
              <div
                id="numberChart"
                style="
                  width: 150px;
                  height: 8rem;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  margin: 10px auto;
                "
              ></div>
              <div
                style="
                  width: calc(100% - 150px);
                  height: 100%;
                  display: flex;
                  flex-direction: column;
                  align-items: center;
                  justify-content: center;
                "
              >
                <div>
                  <span> 已作答 </span>
                  <span> {{ numberChartDetail.alreadyResponse }} </span>
                </div>
                <div style="margin-top: 20px">
                  <span> 未作答 </span>
                  <span> {{ numberChartDetail.noResponse }} </span>
                </div>
              </div>
            </div>
          </div>
          <div class="chart-right-box">
            <h3 style="width: 90%; margin: 10px auto">作答时长统计</h3>
            <div
              id="durationChart"
              style="
                width: 94%;
                height: 12rem;
                display: flex;
                justify-content: center;
                align-items: center;
                margin: 10px auto;
              "
            ></div>
          </div>
        </div>
        <!-- 下方表格区域 -->
        <div class="detail-table-box">
          <ioc-table
            :data="detailTableData"
            :option="detailTableOption"
            :page="detailPage"
            @current-change="selectPage"
            @size-change="changeSize"
            style="height: 415px; overflow-y: auto"
          >
            <template slot="dcRate1" slot-scope="scope">
              <el-button type="text" @click="respondent(scope.row.dcRate1, scope.row)">{{
                scope.row.dcRate1
              }}</el-button>
            </template>
            <template slot="dcRate2" slot-scope="scope">
              <el-button type="text" @click="respondent(scope.row.dcRate2, scope.row)">{{
                scope.row.dcRate2
              }}</el-button>
            </template>
            <template slot="dcRate3" slot-scope="scope">
              <el-button type="text" @click="respondent(scope.row.dcRate3, scope.row)">{{
                scope.row.dcRate3
              }}</el-button>
            </template>
            <template slot="dcRate4" slot-scope="scope">
              <el-button type="text" @click="respondent(scope.row.dcRate4, scope.row)">{{
                scope.row.dcRate4
              }}</el-button>
            </template>
            <template slot="dcRate5" slot-scope="scope">
              <el-button type="text" @click="respondent(scope.row.dcRate5, scope.row)">{{
                scope.row.dcRate5
              }}</el-button>
            </template>
          </ioc-table>
        </div>
      </div>
      <div slot="footer">
        <el-button @click="handleClosePanel">关闭</el-button>
      </div>
    </appPanel>

    <!-- 新增/修改 -->
    <appPanel
      :width="700"
      class="app-panel"
      :isExpand="showAddOrEditPanel"
      @cancel="handleCloseAddOrEditPanel"
      :title="title"
    >
      <!-- 内容区域 -->
      <div class="question-box">
        <el-form
          style="height: 99%; position: absolute; width: 99%"
          :inline="true"
          :model="quesFromInfo"
          :rules="quesFromRule"
          ref="quesFrom"
          label-width="96px"
          label-position="right"
          label-suffix=" ："
        >
          <el-scrollbar style="height: 100%">
            <el-row>
              <el-col :span="24">
                <el-form-item label="问卷标题" prop="title" style="width: 94%">
                  <el-input v-model="quesFromInfo.title" placeholder="请输入问卷标题">
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="问卷类型"
                  prop="type"
                  style="width: 94%"
                  class="ques-type-box"
                >
                  <el-select v-model="quesFromInfo.type" placeholder="请选择">
                    <el-option
                      v-for="item in quesTypeOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                  <p class="desc">(匿名时,参与人员不显示)</p>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="作答时长" prop="answerTime" style="width: 94%">
                  <el-input
                    v-model="quesFromInfo.answerTime"
                    placeholder="请输入作答时长"
                  >
                    <template slot="append">(分钟)</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="quesFromInfo.type != 2">
              <el-col :span="24">
                <el-form-item
                  label="参与人员"
                  prop="questionnairePersonnelListStr"
                  style="width: 94%"
                >
                  <!-- <el-select
                    v-model="quesFromInfo.questionnairePersonnelList"
                    placeholder="请选择"
                    multiple
                    clearable
                  >
                    <el-option
                      v-for="item in participantOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select> -->
                  <el-input
                    v-model="quesFromInfo.questionnairePersonnelListStr"
                    placeholder="请选择参与人员"
                    clearable
                  ></el-input>
                  <img
                    style="cursor: pointer; position: absolute; top: 10px; right: 10px"
                    src="@src/common/assets/images/icon/more.png"
                    @click="openChoosePeople"
                    alt=""
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  label="调查项"
                  prop="questionnaireQuestionListStr"
                  style="width: 94%"
                >
                  <!-- <el-select
                    v-model="quesFromInfo.questionnaireQuestionList"
                    placeholder="请选择"
                    multiple
                    clearable
                  >
                    <el-option
                      v-for="item in surveyItemOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select> -->
                  <el-input
                    type="textarea"
                    :rows="2"
                    readonly
                    v-model="quesFromInfo.questionnaireQuestionListStr"
                    placeholder="请选择调查项"
                    clearable
                  ></el-input>
                  <img
                    style="cursor: pointer; position: absolute; top: 10px; right: 10px"
                    src="@src/common/assets/images/icon/more.png"
                    @click="openChooseQuestion"
                    alt=""
                  />
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="24">
                <el-form-item label="截止时间" prop="cutOffTime" style="width: 100%">
                  <el-date-picker
                    v-model="quesFromInfo.cutOffTime"
                    type="datetime"
                    style="width: 94%"
                    placeholder="选择日期时间"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-scrollbar>
        </el-form>
      </div>

      <!-- 按钮区域 -->
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAddOrEditPanel" type="info" :loading="subLoading">
          取消
        </el-button>
        <el-button type="primary" :loading="subLoading" @click="handleSaveAddOrEditPanel">
          {{ subLoading ? "提交中" : "确定" }}
        </el-button>
      </span>
    </appPanel>

    <!-- 人员选择弹框 -->
    <el-dialog
      title="参与人员选择"
      :append-to-body="true"
      :visible.sync="dialogPeople"
      width="50%"
      class="choose-container"
    >
      <div style="height: 580px">
        <ioc-table
          ref="personTable"
          :data="personData"
          :option="personOption"
          :page="personPage"
          @size-change="personChangeSize"
          @current-change="currentChange"
          @search-change="searchList"
          @search-reset="personReset"
          @selection-change="handlePersonSelectionChange"
        >
          <template slot="status" slot-scope="scope">
            <span v-if="scope.row.status === 1" style="color: #00e8bb">{{
              onJobFormatter(scope.row)
            }}</span>
            <span v-if="scope.row.status === 2">{{ onJobFormatter(scope.row) }}</span>
            <span v-if="scope.row.status === 4" style="color: yellow">{{
              onJobFormatter(scope.row)
            }}</span>
          </template>
        </ioc-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelChoose">取消</el-button>
        <el-button type="primary" @click="confirmChoose">确认</el-button>
      </span>
    </el-dialog>

    <!-- 问题选择弹窗 -->
    <el-dialog
      title="调查项选择"
      :append-to-body="true"
      :visible.sync="dialogQuestion"
      width="50%"
      class="choose-container"
    >
      <div style="height: 580px">
        <ioc-table
          ref="questionTable"
          :data="questionData"
          :option="questionOption"
          :page="questionPage"
          @size-change="questionChangeSize"
          @current-change="questionCurrentChange"
          @search-change="questionSearchList"
          @search-reset="questionReset"
          @selection-change="handleQuestionSelectionChange"
        >
          <template slot="status" slot-scope="scope">
            <span v-if="scope.row.status === 1" style="color: #00e8bb">{{
              onJobFormatter(scope.row)
            }}</span>
            <span v-if="scope.row.status === 2">{{ onJobFormatter(scope.row) }}</span>
            <span v-if="scope.row.status === 4" style="color: yellow">{{
              onJobFormatter(scope.row)
            }}</span>
          </template>
        </ioc-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" @click="cancelQuestionChoose">取消</el-button>
        <el-button type="primary" @click="confirmQuestionChoose">确认</el-button>
      </span>
    </el-dialog>

    <!-- 二维码放大 -->
    <el-dialog title="调查问卷二维码" :visible.sync="showQrCode" width="340px">
      <vue-qr
        :logoSrc="downloadData.icon"
        :text="downloadData.url"
        :size="300"
        id="printTest"
        :margin="6"
      ></vue-qr>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showQrCode = false">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog title="选项人员" :visible.sync="optionPersonShow" width="35%">
      <div>
        {{ respondentStr }}
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="optionPersonShow = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import vueQr from "vue-qr";
import echarts from "echarts";
import { api } from "../api/index";
import appPanel from "@src/components/business/app-panel/index.vue";
import { Dic, Bus, Dates } from "$utils";
import utils from "@src/common/utils";
import { tableOption } from "../config/questionManageTable";
import { detailTableOption } from "../config/questionDetailTable";
import { personOption } from "../config/personTable";
import { questionOption } from "../config/questionTable";
export default {
  components: {
    appPanel,
    vueQr,
  },
  data() {
    return {
      respondentStr: "",
      optionPersonShow: false,
      showQrCode: false,
      downloadData: {
        // url: "http://10.40.146.150:8081/#/pages/workorder/handle-add?templateCode=20210617000495"//需要转化成二维码的网址
        url: "", //需要转化成二维码的网址
        icon: require("../../../../src/common/assets/images/wx.png"), //二维码中间的图片,可以不设置
      },
      h5Url: "https://universal.u-cold.com:18443/questionnaire", // utils.Cache.get("SYS_H5"),//小程序链接地址
      showPanel: false,
      viewerInstance: null,
      tableOption: tableOption(),
      getTimeOut: null,
      // 分页属性设置
      page: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      tableData: [],
      searchParams: {},
      // 问卷详情图表数据
      numberChartDetail: {
        alreadyResponse: 0,
        noResponse: 0,
        percent: 0,
        percentValue: 0,
      },
      durationChartDetail: {
        xData: [],
        yData: [],
      },
      // 问卷详情表格数据
      detailId: -1,
      detailTableData: [],
      detailTableOption: detailTableOption(),
      detailPage: {
        currentPage: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },

      // 选择的quesId
      checkedQuesIds: [],
      // 新增/修改表格
      subLoading: false,
      title: "",
      showAddOrEditPanel: false,
      quesFromInfo: {
        // 接口数据字段
        id: -1,
        title: "", // 问卷名称
        status: 1, // 新增默认写死，修改不传递此参数
        type: 1, // 问卷类型
        answerTime: 0, // 作答时长
        cutOffTime: "", // 截止时间
        questionnaireQuestionList: [], // 调查项信息
        questionnaireQuestionListStr: "",
        questionnairePersonnelList: [], // 参与人员
        questionnairePersonnelListStr: "",
      },
      quesFromRule: {
        title: [
          {
            required: true,
            message: "请输入问卷标题",
            trigger: ["blur", "change"],
          },
        ],
        type: [
          {
            required: true,
            message: "请选择问卷类型",
            trigger: ["blur", "change"],
          },
        ],
        answerTime: [
          {
            required: true,
            message: "请输入作答时长",
            trigger: ["blur", "change"],
          },
        ],
        questionnairePersonnelList: [
          {
            required: true,
            message: "请选择参与人员",
            trigger: ["blur", "change"],
          },
        ],
        questionnairePersonnelListStr: [
          {
            required: true,
            message: "请选择参与人员",
            trigger: ["blur", "change"],
          },
        ],
        questionnaireQuestionList: [
          {
            required: true,
            message: "请选择调查项",
            trigger: ["blur", "change"],
          },
        ],
        questionnaireQuestionListStr: [
          {
            required: true,
            message: "请选择调查项",
            trigger: ["blur", "change"],
          },
        ],
        cutOffTime: [
          {
            required: true,
            message: "请选择截止时间",
            trigger: ["blur", "change"],
          },
        ],
      },
      // 下拉选项信息
      // quesStatusOptions: [
      //   {
      //     value: "1",
      //     label: "未发布",
      //   },
      //   {
      //     value: "2",
      //     label: "已发布",
      //   },
      //   {
      //     value: "",
      //     label: "全部",
      //   },
      // ],
      quesStatusOptions: [
        {
          value: "1",
          label: "未发布",
        },
        {
          value: "2",
          label: "已发布",
        },
      ],
      // quesTypeOptions: [
      //   {
      //     value: 1,
      //     label: "实名",
      //   },
      //   {
      //     value: 2,
      //     label: "匿名",
      //   },
      //   {
      //     value: 3,
      //     label: "全部",
      //   },
      // ],
      quesTypeOptions: [
        {
          value: 1,
          label: "实名",
        },
        {
          value: 2,
          label: "匿名",
        },
      ],
      participantOptions: [],
      surveyItemOptions: [],
      durationChart: null,
      numberChart: null,
      // 调查项
      checkQuestionInfo: [],
      questionSearch: {},
      dialogQuestion: false,
      questionPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      questionData: [],
      questionOption: questionOption(),
      // 参与人员
      checkPeopleInfo: [],
      personSearch: {
        pageNum: 1,
        total: 10,
        nickName: "",
      },
      dialogPeople: false,
      personPage: {
        pageNum: 1,
        total: 10,
        pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      },
      personData: [],
      personOption: personOption(),
    };
  },
  mounted() {
    // this.getList();
    this.getQuestionList();
    // 获取人员信息
    this.getPersonList();
    // 获取调查项信息
    this.getSurveyItemList();
  },
  beforeDestroy() {},
  methods: {
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    showCode(rowInfo) {
      this.showQrCode = true;
      this.downloadData.url = this.h5Url + "?id=" + rowInfo.id + "&type=" + rowInfo.type;
      console.log(this.downloadData);
    },
    showViewer(url, e) {
      this.$app.AppInstance.handleShowViewer([e.target.src]);
    },
    // 获取参与人员信息
    getPersonList() {
      const params = {};
      // params.personnelType = 1;
      // params.workNo = this.personSearch.workNo;
      // params.name = this.personSearch.name;
      params.pageNo = this.personPage.pageNum;
      params.pageSize = this.personPage.pageSize;
      params.nickName = this.personSearch.nickName;
      params.containOwnFlag = "1";
      this.$fetch(api.questionManage.queryAllPersonnelList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }

        this.personData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.personPage.total = response.returnObj ? response.returnObj.total : 0;
        // console.log("---人员列表信息:--", this.personData);
      });
    },
    //  获取调查项信息
    getSurveyItemList() {
      const params = {};
      // params.personnelType = 1;
      // params.workNo = this.personSearch.workNo;
      // params.name = this.personSearch.name;
      params.categoryName = this.questionSearch.category;
      params.title = this.questionSearch.title;
      params.pageNum = this.questionPage.pageNum;
      params.pageSize = this.questionPage.pageSize;
      params.status = 1;
      this.$fetch(api.questionManage.queryAllQuestionList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.questionData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.questionPage.total = response.returnObj ? response.returnObj.total : 0;
        // console.log("---调查项列表信息:--", this.questionData);
      });
    },
    // 获取调查项信息
    getSurveyItem() {},
    // 获取调查问卷管理列表
    getQuestionList() {
      const params = {};
      params.pageNum = this.page.currentPage;
      params.pageSize = this.page.pageSize;

      params.status = Number(this.searchParams.status);
      params.type = Number(this.searchParams.type);
      params.title = this.searchParams.title;

      this.$fetch(api.questionManage.queryQuestionnaireList, params).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        }
        this.tableData = response.returnObj
          ? Object.freeze([...response.returnObj.list])
          : [];
        this.page.total = response.returnObj ? response.returnObj.total : 0;
        this.$refs.accessTab.selectClear();
      });
    },
    // TODO获取列表
    getList() {
      this.tableData = [
        {
          quesTitle: "问卷调查一",
          quesType: "0",
          quesStatus: "0",
          createTime: "2023-01-30T10:15:00.000+0800",
          creator: "admin",
          endTime: "2023-01-30T23:23:00.000+0800",
          qrCode: "",
          quesId: "001",
        },
        {
          quesTitle: "问卷调查二",
          quesType: "1",
          quesStatus: "1",
          createTime: "2023-01-30T01:01:00.000+0800",
          creator: "admin",
          endTime: "2023-01-30T22:22:00.000+0800",
          qrCode: "",
          quesId: "002",
        },
      ];
      this.page.total = this.tableData.length;
    },
    // 获取问卷详情信息
    handleQuestionDetailInfo(row) {
      this.detailId = row.id;
      this.$fetch(api.questionManage.queryQuestionnaire, {
        id: this.detailId,
      }).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          let detailObj = response.returnObj;
        }
      });
    },
    // 详情操作
    handleView(row, index) {
      // console.log("--详情--row:--", row);
      this.detailId = row.id;
      // console.log("--详情--this.detailId:--", this.detailId);
      this.showPanel = true;
      // 获取详情信息
      // this.getDetailList();
      // this.getTableDetailData();
      // 图表信息
      this.getRespondNumberData();
      this.getRespondDurationData();
      this.getTableDetailData();
      // this.initNumberChartData();
      // this.initDurationChartData();
      window.onresize = () => {
        this.durationChart.resize();
        this.numberChart.resize();
      };
    },
    //关闭详情
    handleClosePanel() {
      this.showPanel = false;
    },

    closeDialog() {},

    // 查询按钮事件
    searchResult(param) {
      // console.log("---查询--param:--", param);
      this.searchParams = param;
      // console.log("---查询--this.searchParams:--", this.searchParams);
      this.page.currentPage = 1;
      // this.getList();
      this.getQuestionList();
    },
    // 重置按钮
    resetQuery() {
      // console.log("---重置--this.searchParams:--", this.searchParams);
      // this.getList();
      this.getQuestionList();
    },
    // 点击上一页下一页按钮
    selectPage(val) {
      this.page.currentPage = val;
      // this.getList();
      this.getQuestionList();
    },
    // 修改每页数据数量
    changeSize(val) {
      this.page.currentPage = 1;
      this.page.pageSize = val;
      // this.getList();
      this.getQuestionList();
    },
    // 表格详情数据
    detailSelectPage(val) {
      this.detailPage.currentPage = val;
      // this.getDetailList();
      this.getTableDetailData();
    },
    detailChangeSize(val) {
      this.detailPage.currentPage = 1;
      this.detailPage.pageSize = val;
      // this.getDetailList();
      this.getTableDetailData();
    },
    getDetailList() {
      this.detailTableData = [
        {
          dcItem: "安全手册获取1",
          dcRate1: "A/10",
          dcRate2: "B/20",
          dcRate3: "c/10",
          dcRate4: "D/20",
          dcRate5: "E/10",
          dcRate6: "F/10",
        },
        {
          dcItem: "安全手册获取2",
          dcRate1: "A/10",
          dcRate2: "B/20",
          dcRate3: "c/10",
          dcRate4: "D/20",
          dcRate5: "E/10",
          dcRate6: "F/10",
        },
        {
          dcItem: "安全手册获取3",
          dcRate1: "A/10",
          dcRate2: "B/20",
          dcRate3: "c/10",
          dcRate4: "D/20",
          dcRate5: "E/10",
          dcRate6: "F/10",
        },
        {
          dcItem: "安全手册获取4",
          dcRate1: "A/10",
          dcRate2: "B/20",
          dcRate3: "c/10",
          dcRate4: "D/20",
          dcRate5: "E/10",
          dcRate6: "F/10",
        },
        {
          dcItem: "安全手册获取5",
          dcRate1: "A/10",
          dcRate2: "B/20",
          dcRate3: "c/10",
          dcRate4: "D/20",
          dcRate5: "E/10",
          dcRate6: "F/10",
        },
        {
          dcItem: "安全手册获取6",
          dcRate1: "A/10",
          dcRate2: "B/20",
          dcRate3: "c/10",
          dcRate4: "D/20",
          dcRate5: "E/10",
          dcRate6: "F/10",
        },
        {
          dcItem: "安全手册获取7",
          dcRate1: "A/10",
          dcRate2: "B/20",
          dcRate3: "c/10",
          dcRate4: "D/20",
          dcRate5: "E/10",
          dcRate6: "F/10",
        },
      ];
    },
    // 获取调查项表格详情数据
    getTableDetailData() {
      let param = {
        id: this.detailId,
        pageNum: this.detailPage.currentPage,
        pageSize: this.detailPage.pageSize,
      };
      this.$fetch(api.questionManage.queryQuestionCount, param).then((response) => {
        this.detailTableData = [];
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          let detailArr = response.returnObj.list;
          if (detailArr.length > 0) {
            this.detailTableData = detailArr.map((item) => {
              let newItem = {
                id: item.id,
                dcItem: item.title,
                dcRate1: item.A,
                dcRate2: item.B,
                dcRate3: item.C,
                dcRate4: item.D,
                dcRate5: item.E,
              };
              return newItem;
            });
          }
        }
      });
    },
    respondent(item, data) {
      this.respondentStr = "";
      let option = item.substr(0, 1);
      let param = {
        questionId: this.detailId,
        questionnaireId: data.id,
        answer: option,
      };
      this.$fetch(api.questionManage.queryOptionPersonnel, param).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          this.respondentStr = response.returnObj;
          if (this.respondentStr) {
            this.optionPersonShow = true;
          } else {
            this.$message.warning("暂无选项人员");
          }
        }
      });
    },
    // 获取作答人数统计数据
    getRespondNumberData() {
      this.$fetch(api.questionManage.queryPersonnelCount, {
        id: this.detailId,
      }).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          let detailObj = response.returnObj;
          this.numberChartDetail.alreadyResponse = detailObj.alreadyResponse;
          this.numberChartDetail.noResponse = detailObj.noResponse;
          this.numberChartDetail.percent = detailObj.percent;
          this.numberChartDetail.percentValue = detailObj.percent * 100;
          // 更新图表数据
          this.initNumberChartData();
        }
      });
    },
    // 获取作答时长统计数据
    getRespondDurationData() {
      this.$fetch(api.questionManage.queryQuestionnaireCount, {
        id: this.detailId,
      }).then((response) => {
        if (!response.success) {
          this.$message.error(response.msgContent);
          return;
        } else {
          let detailObj = response.returnObj;
          if (JSON.stringify(detailObj) !== "{}") {
            this.durationChartDetail.xData = Object.keys(detailObj);
            this.durationChartDetail.yData = Object.values(detailObj);
          }
          // 更新图表数据
          this.initDurationChartData();
        }
      });
    },
    // 初始化表格数据
    initDurationChartData() {
      this.durationChart = echarts.init(document.getElementById("durationChart"));
      let durationOption = {
        xAxis: {
          type: "category",
          // data: ["1~30", "30~60", "60~120", "120~240", "240-480"],
          data: this.durationChartDetail.xData,
          axisLine: {
            show: true,
            lineStyle: {
              // color: "white",
            },
          },
        },
        yAxis: {
          minInterval: 1,
          // name: "作答时长统计",
          // nameTextStyle: {
          //   color: "white",
          // },
          type: "value",
          axisLine: {
            show: true,
            lineStyle: {
              // color: "white",
            },
          },
          splitLine: {
            lineStyle: {
              // color: "white",
              type: "dashed",
              width: 1,
            },
          },
        },
        series: [
          {
            // data: [120, 200, 150, 80, 70],
            data: this.durationChartDetail.yData,
            type: "bar",
            itemStyle: {
              color: "#7ECF51",
            },
          },
        ],
      };
      // console.log(durationOption)
      this.durationChart.setOption(durationOption);
    },
    initNumberChartData() {
      // console.log("-------------------");
      this.numberChart = echarts.init(document.getElementById("numberChart"));
      let numberOption = {
        series: [
          {
            pointer: {
              show: false,
            },
            type: "gauge",
            progress: {
              show: true,
              width: 18,
            },
            axisLine: {
              lineStyle: {
                width: 18,
                color: [
                  [this.numberChartDetail.percent, "#4CD29D"],
                  [1, "#07090E"],
                ],
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
            },
            axisLabel: {
              show: false,
              distance: 25,
              color: "#999",
              fontSize: 16,
            },
            anchor: {
              show: false,
              showAbove: false,
              size: 25,
              itemStyle: {
                borderWidth: 10,
              },
            },
            detail: {
              color: "white",
              valueAnimation: false,
              fontSize: 18,
              offsetCenter: ["8%", "8%"],
            },
            data: [
              {
                // value: 70,
                value: this.numberChartDetail.percentValue,
                itemStyle: {
                  color: "white",
                  borderColor: "white",
                },
              },
            ],
          },
        ],
      };
      // console.log("-------------------");
      this.numberChart.setOption(numberOption);
    },
    handleSelectionChange(items) {
      // console.log("---select--items:--", items);

      if (!items || !items.length) {
        this.checkedQuesIds = [];
      } else {
        this.checkedQuesIds = items.map((item) => {
          return item.id;
        });
      }
      // console.log("----this.checkedQuesIds:---", this.checkedQuesIds);
    },
    // 新增操作
    handleAddCar() {
      // console.log("新增调查问卷");
      this.quesFromInfo.id = undefined;
      this.title = "新增调查问卷";
      this.showAddOrEditPanel = true;
    },
    // 批量删除操作
    handelDelQues() {
      // console.log("批量删除操作");
      this.$confirm("您确定批量删除选择的问卷信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.questionManage.deleteQuestionnaire, this.checkedQuesIds).then(
          (response) => {
            if (response && response.success) {
              this.$message({
                message: "删除成功",
                type: "success",
                duration: 2000,
              });
            } else {
              this.$message({
                message: response.msgContent,
                type: "error",
                duration: 2000,
              });
            }
            this.getQuestionList();
          }
        );
      });
    },
    // 编辑操作
    handleEditOpt(row, index) {
      // console.log("--修改()--row:--", row);
      this.title = "修改调查问卷";
      this.quesFromInfo.id = row.id;
      this.quesFromInfo.title = row.title;
      this.quesFromInfo.status = row.status;
      this.quesFromInfo.type = row.type;
      this.quesFromInfo.answerTime = row.answerTime;
      this.quesFromInfo.cutOffTime = row.cutOffTime;
      this.quesFromInfo.questionnaireQuestionList = row.questionIdList;
      this.quesFromInfo.questionnairePersonnelList = row.personnelIdList;
      this.quesFromInfo.questionnaireQuestionListStr = row.questionStr;
      this.quesFromInfo.questionnairePersonnelListStr = row.personnelStr;
      // console.log("---修改---this.quesFromInfo:---", this.quesFromInfo);
      this.showAddOrEditPanel = true;
    },
    // 发布操作
    handlePublish(row) {
      // console.log("发布操作");
      this.$confirm("您确定发布该问卷信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.questionManage.publishQuestionnaire, {
          id: row.id,
        }).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "发布成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getQuestionList();
        });
      });
    },
    // 单个删除操作
    handleDel(row) {
      // console.log("单个删除操作");

      this.$confirm("您确定删除该问卷信息吗?", "删除确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$fetch(api.questionManage.deleteQuestionnaire, [row.id]).then((response) => {
          if (response && response.success) {
            this.$message({
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$message({
              message: response.msgContent,
              type: "error",
              duration: 2000,
            });
          }
          this.getQuestionList();
        });
      });
    },
    // 关闭新增/修改 弹窗
    handleCloseAddOrEditPanel() {
      // TODO处理from表单取消校验操作
      this.handleRestForm();
      // this.getList();
      this.getQuestionList();
      this.showAddOrEditPanel = false;
    },
    // 保存新增/修改 弹窗
    handleSaveAddOrEditPanel() {
      // TODO处理from表单校验操作
      // 新增/修改成功后的操作
      this.$refs.quesFrom.validate((valid) => {
        if (valid) {
          let params = { ...this.quesFromInfo };
          params.answerTime = Number(params.answerTime);
          params.cutOffTime = params.cutOffTime ? Dates.format(params.cutOffTime) : "";
          if (params.id) {
            // 修改
            params.type = undefined;
            this.$fetch(api.questionManage.updateQuestionnaire, params).then(
              (response) => {
                if (!response.success) {
                  this.$message.error(response.msgContent);
                } else {
                  this.$message.success("修改成功！");
                }
                // 关闭弹窗
                this.showAddOrEditPanel = false;
                this.handleRestForm();
                // 刷新列表数据
                // this.getList();
                this.getQuestionList();
              }
            );
          } else {
            // 新增
            this.$fetch(api.questionManage.addQuestionnaire, params).then((response) => {
              if (!response.success) {
                this.$message.error(response.msgContent);
              } else {
                this.$message.success("新增成功！");
              }
              // 关闭弹窗
              this.showAddOrEditPanel = false;
              this.handleRestForm();
              // 刷新列表数据
              // this.getList();
              this.getQuestionList();
            });
          }
        } else {
          return false;
        }
      });
    },
    // 重置表单操作
    handleRestForm() {
      this.quesFromInfo.id = undefined;
      this.quesFromInfo.title = ""; // 问卷名称
      this.quesFromInfo.status = 1; // 新增默认写死，修改不传递此参数
      this.quesFromInfo.type = 1; // 问卷类型
      this.quesFromInfo.answerTime = 0; // 作答时长
      this.quesFromInfo.cutOffTime = ""; // 截止时间
      this.quesFromInfo.questionnaireQuestionList = []; // 调查项信息
      this.quesFromInfo.questionnairePersonnelList = []; // 参与人员
      this.quesFromInfo.questionnaireQuestionListStr = ""; // 调查项信息
      this.quesFromInfo.questionnairePersonnelListStr = ""; // 参与人员
      this.$refs["quesFrom"].clearValidate();
    },
    // 选择调查项相关操作
    openChooseQuestion() {
      this.dialogQuestion = true;
      // console.log("选择问题项");
    },
    questionChangeSize(val) {
      this.questionPage.pageNum = 1;
      this.questionPage.pageSize = val;
      this.getSurveyItemList();
    },
    questionCurrentChange(val) {
      this.questionPage.pageNum = val;
      this.getSurveyItemList();
    },
    questionSearchList(param) {
      this.questionSearch = Object.assign(param);
      this.questionPage.pageNum = 1;
      this.getSurveyItemList();
    },
    questionReset() {
      this.getSurveyItemList();
    },
    questionRadio(item) {
      this.checkQuestionInfo = item;
    },
    handleQuestionSelectionChange(items) {
      // console.log("--questionItems:--", items);
      if (!items || !items.length) {
        this.checkQuestionInfo = [];
      } else {
        this.checkQuestionInfo = items.map((item) => {
          let newItem = {
            label: item.title,
            value: item.id,
          };
          return newItem;
        });
      }
      // console.log("--checkQuestionInfo:--", this.checkQuestionInfo);
    },
    cancelQuestionChoose() {
      this.$refs.questionTable.selectClear();
      this.dialogQuestion = false;
      this.checkQuestionInfo = [];
    },
    confirmQuestionChoose() {
      if (!this.checkQuestionInfo || !this.checkQuestionInfo.length) {
        this.$message.warning("请选择调查项");
        return;
      }

      // console.log("----confirmQuestionChoose()----");
      this.quesFromInfo.questionnaireQuestionList = [];
      let questionnaireQuestionListStr = [];
      this.quesFromInfo.questionnaireQuestionListStr = "";
      // console.log("----this.checkQuestionInfo:---", this.checkQuestionInfo);
      this.checkQuestionInfo.forEach((pItem) => {
        this.quesFromInfo.questionnaireQuestionList.push(pItem.value); // 问题id
        questionnaireQuestionListStr.push(pItem.label); // 调查项名称
      });
      this.quesFromInfo.questionnaireQuestionListStr = questionnaireQuestionListStr.join(
        ","
      );
      // console.log("----list:---", this.quesFromInfo.questionnaireQuestionList);
      // console.log("-str:-", this.quesFromInfo.questionnaireQuestionListStr);

      this.cancelQuestionChoose();
    },
    // 选择参与人员相关操作
    openChoosePeople() {
      this.dialogPeople = true;
    },
    personChangeSize(val) {
      this.personPage.pageNum = 1;
      this.personPage.pageSize = val;
      this.getPersonList();
    },
    currentChange(val) {
      this.personPage.pageNum = val;
      this.getPersonList();
    },
    searchList(param) {
      // console.log("---param:--", param);
      this.personSearch = Object.assign(param);
      // console.log("--this.personSearch:--", this.personSearch);
      this.personPage.pageNum = 1;
      this.getPersonList();
    },
    personReset() {
      this.personPage.pageNum = 1;
      this.personPage.pageSize = 10;
      this.personSearch.nickName = "";
      this.getPersonList();
    },
    handlePersonSelectionChange(items) {
      if (!items || !items.length) {
        this.checkPeopleInfo = [];
      } else {
        this.checkPeopleInfo = items.map((item) => {
          let newItem = {
            label: item.nickName,
            value: item.accountNumber,
          };
          return newItem;
        });
      }
    },
    // 人员取消
    cancelChoose() {
      this.$refs.personTable.selectClear();
      this.dialogPeople = false;
      this.checkPeopleInfo = [];
    },
    // 人员确定
    confirmChoose() {
      if (!this.checkPeopleInfo || !this.checkPeopleInfo.length) {
        this.$message.warning("请选择人员");
        return;
      }
      // console.log("----confirmChoose()----");
      this.quesFromInfo.questionnairePersonnelList = [];
      let questionnairePersonnelListStr = [];
      this.quesFromInfo.questionnairePersonnelListStr = "";
      // console.log("----this.checkPeopleInfo:---", this.checkPeopleInfo);
      this.checkPeopleInfo.forEach((pItem) => {
        this.quesFromInfo.questionnairePersonnelList.push(pItem.value); // 人员accountNumber
        questionnairePersonnelListStr.push(pItem.label); // 人员nickName
      });
      this.quesFromInfo.questionnairePersonnelListStr = questionnairePersonnelListStr.join(
        ","
      );
      // console.log("----list:---", this.quesFromInfo.questionnairePersonnelList);
      // console.log("-str:-", this.quesFromInfo.questionnairePersonnelListStr);
      this.cancelChoose();
    },
    onJobFormatter(data) {
      switch (data.onJob * 1) {
        case 1:
          return "在职";
        case 2:
          return "离职";
        case 4:
          return "未知";
        default:
          return data.onJob;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.panel-content {
  .content-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .info-item {
    margin: 15px 0px;
    // width: 50%;
  }

  .item-img {
    margin: 15px 0px;
  }

  .label {
    padding: 0 20px;
    width: 100px;
    text-align: center;
  }

  .detail-info {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    flex-wrap: wrap;
  }
}

.access-record-container {
  width: 100%;
  height: 100%;

  .el-table__fixed-right-patch {
    display: none;
  }

  .el-dialog {
    .el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 260px;
    }
  }
}

.car-info-box {
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 18px;
    display: flex;
    width: 100%;

    .el-form-item__content {
      flex: 1;
    }
  }
}

.question-box {
  padding: 20px;

  ::v-deep .el-form-item__content {
    width: 80%;
  }

  ::v-deep .el-select {
    width: 100%;
  }

  .ques-type-box {
    display: flex;

    ::v-deep .el-form-item__content {
      display: flex;
    }

    .desc {
      width: 155px;
      margin-left: 5px;
    }

    ::v-deep .el-select {
      width: 0px;
      flex: 1;
    }
  }

  ::v-deep .el-range-editor--small.el-input__inner {
    width: 95%;
  }

  ::v-deep .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 37vw;
  }
}

.question-detail-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  .detail-chart-box {
    width: 100%;
    height: 220px;
    display: flex;
    flex-direction: row;

    .chart-left-box {
      width: 280px;
      height: 220px;
      border: 1px solid white;
      border-radius: 10px;

      // flex: 1;
      .left-content-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        height: calc(100% - 42px);
      }
    }

    .chart-right-box {
      width: calc(100% - 320px);
      margin-left: 40px;
      height: 220px;
      border: 1px solid white;
      border-radius: 10px;
    }
  }

  .detail-table-box {
    width: 100%;
    height: calc(100% - 220px);
  }
}
</style>

<style scoped>
::v-deep.el-picker-panel {
  width: 37vw;
}

::v-deep .el-date-picker .el-picker-panel__content {
  width: 34vw;
}
</style>

<style lang="scss">
.question-manage .el-table__body-wrapper {
  height: 100%;
  overflow-y: auto;
}
</style>
